import { useState } from 'react';
import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import Icon from '../../components/common/Icon';
import './FraudDashboard.css';

const MOCK_FRAUD_EVENTS = [
  {
    id: 1,
    phone: '+1666555...',
    tenant: 'L100.ai',
    time: '12:35:02',
    ip: '10.0.0.1',
    location: 'Moscow, RU',
    signals: [
      { type: 'geo', label: 'Blocked Country' },
      { type: 'voip', label: 'VOIP Detected' }
    ],
    riskScore: 87
  },
  {
    id: 2,
    phone: '+1777888...',
    tenant: 'Cachee',
    time: '12:33:47',
    ip: '192.168.1.50',
    location: 'New York, US',
    signals: [
      { type: 'velocity', label: 'Velocity Limit' },
      { type: 'bot', label: 'Bot Score: 78' }
    ],
    riskScore: 92
  },
  {
    id: 3,
    phone: '+1888999...',
    tenant: 'SuperSearch.ai',
    time: '12:32:18',
    ip: '172.16.0.1',
    location: 'London, GB',
    signals: [
      { type: 'voip', label: 'VOIP (Twilio)' }
    ],
    riskScore: 54
  }
];

const FraudDashboard = () => {
  const [activeTab, setActiveTab] = useState('ip');

  const stats = [
    { label: 'Blocked (24h)', value: '234', change: '+12% vs yesterday', changeType: 'negative' },
    { label: 'Flagged', value: '89', change: 'For review', changeType: 'warning' },
    { label: 'Avg Risk Score', value: '42', change: 'Out of 100', changeType: 'positive' },
  ];

  const getRiskClass = (score) => {
    if (score >= 70) return 'risk-high';
    if (score >= 40) return 'risk-medium';
    return 'risk-low';
  };

  return (
    <div className="fraud-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Fraud Detection Center</h1>
          <p className="page-subtitle">Monitor and manage fraud prevention</p>
        </div>
        <div className="page-actions">
          <Button variant="secondary" icon="settings">Configure</Button>
          <Button variant="primary" icon="shield">Review Queue</Button>
        </div>
      </div>

      <div className="stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      {/* Alert Banner */}
      <div className="alert alert-danger">
        <Icon name="alert-triangle" size="md" />
        <span><strong>Fraud Spike Detected:</strong> 47 blocks in last 15 minutes from RU</span>
      </div>

      {/* Live Feed Section */}
      <section className="section">
        <div className="section-header">
          <h3 className="section-title">Live Fraud Feed</h3>
          <Button variant="ghost" size="sm" icon="refresh">Refresh</Button>
        </div>

        <div className="fraud-feed">
          {MOCK_FRAUD_EVENTS.map((event) => (
            <div key={event.id} className="fraud-event">
              <div className="fraud-event-info">
                <div className="fraud-event-title">{event.phone} • {event.tenant}</div>
                <div className="fraud-event-meta">{event.time} • {event.ip} • {event.location}</div>
                <div className="fraud-signals">
                  {event.signals.map((signal, idx) => (
                    <span key={idx} className={`signal-badge signal-${signal.type}`}>
                      {signal.label}
                    </span>
                  ))}
                </div>
              </div>
              <div className="risk-score">
                <div className={`risk-value ${getRiskClass(event.riskScore)}`}>
                  {event.riskScore}
                </div>
                <div className="risk-label">Risk</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Blocklists Section */}
      <section className="section">
        <div className="tabs">
          <button
            className={`tab ${activeTab === 'ip' ? 'active' : ''}`}
            onClick={() => setActiveTab('ip')}
          >
            IP Blocklist
          </button>
          <button
            className={`tab ${activeTab === 'phone' ? 'active' : ''}`}
            onClick={() => setActiveTab('phone')}
          >
            Phone Blocklist
          </button>
          <button
            className={`tab ${activeTab === 'device' ? 'active' : ''}`}
            onClick={() => setActiveTab('device')}
          >
            Device Blocklist
          </button>
        </div>

        <div className="alert alert-info">
          <span>
            <strong>
              {activeTab === 'ip' && 'IP Blocklist:'}
              {activeTab === 'phone' && 'Phone Blocklist:'}
              {activeTab === 'device' && 'Device Blocklist:'}
            </strong>
            {' '}
            {activeTab === 'ip' && '2,847 IPs currently blocked'}
            {activeTab === 'phone' && '1,234 phone numbers blocked'}
            {activeTab === 'device' && '567 device fingerprints blocked'}
          </span>
          <Button variant="secondary" size="sm" icon="plus">
            Add {activeTab === 'ip' ? 'IP' : activeTab === 'phone' ? 'Phone' : 'Device'}
          </Button>
        </div>
      </section>
    </div>
  );
};

export default FraudDashboard;
